export default {
    title: "What's this?",
    description: 'The service fee is non-refundable if you cancel your booking. This fee helps us maintain and improve our booking platform, ensuring a seamless experience for all users. For more information, please see the FAQ in your Account Settings.'
}